/**
 * Mock website settings. Once the backend "settings" endpoint is available,
 * this file becomes redundant and settings.service.js can be swapped to a
 * fetch call. Interfaces mirror `WebsiteSettings` from the spec.
 */
import { siteConfig } from "@/config/site.config";

export const mockWebsiteSettings = {
    siteName: siteConfig.siteName,
    registeredCompanyName: siteConfig.registeredCompanyName,
    uen: siteConfig.uen,
    email: siteConfig.email,
    mobile: siteConfig.mobile,
    whatsappNumber: siteConfig.whatsappNumber,
    whatsappUrl: siteConfig.whatsappUrl,
    address: siteConfig.address.full,
    logoUrl: "",
    faviconUrl: "",
    defaultSeo: {
        ...siteConfig.defaultSeo,
        slug: "/",
    },
    headerCode: "",
    bodyStartCode: "",
    bodyEndCode: "",
    googleMapsEmbedUrl: siteConfig.googleMapsEmbedUrl,
    socialLinks: siteConfig.socialLinks,
};

/**
 * Page-key -> SEO override map. When a page-specific override is present, it
 * replaces the corresponding field of the site's default SEO. Extend freely.
 */
export const mockPageSeo = {
    home: {
        title: "New, Used & Customised Containers Singapore | Container Specialist",
        description:
            "Buy new, used and customised shipping containers in Singapore. Storage, office, cargo-worthy, workers' quarters, sanitary and custom container solutions from Container Specialist.",
        keywords: [
            "containers Singapore",
            "shipping containers for sale Singapore",
            "new containers Singapore",
            "used containers Singapore",
            "customised containers Singapore",
        ],
        slug: "/",
    },
    about: {
        title: "About Container Specialist | MK Holdings Pte Ltd",
        description:
            "Container Specialist has served Singapore since 2010, supplying new, used and customised shipping containers for businesses and organisations.",
        keywords: ["about Container Specialist", "MK Holdings Pte Ltd", "container supplier Singapore"],
        slug: "/about-us",
    },
    containers: {
        title: "Our Containers | Container Specialist Singapore",
        description:
            "Browse new, used and customised container listings by category, size, condition and application.",
        keywords: ["containers Singapore", "container catalogue"],
        slug: "/containers",
    },
    blogs: {
        title: "Container Guides, Ideas & Buying Advice | Container Specialist",
        description:
            "Learn how to select, use, maintain and customise shipping containers for different commercial and operational requirements.",
        keywords: ["container blog Singapore", "shipping container guide"],
        slug: "/blogs",
    },
    contact: {
        title: "Contact Container Specialist Singapore | WhatsApp, Phone, Email",
        description:
            "Contact Container Specialist for new, used and customised container enquiries. WhatsApp, phone or email.",
        keywords: ["contact container supplier Singapore", "container quote Singapore"],
        slug: "/contact-us",
    },
    customised: {
        title: "Customised Containers Singapore | Container Specialist",
        description:
            "Customised shipping containers designed around your operations — offices, guard houses, workers' facilities and more.",
        keywords: ["customised container Singapore", "container conversion"],
        slug: "/containers/customised-containers",
    },
    privacy: { title: "Privacy Policy | Container Specialist", description: "Privacy policy for Container Specialist.", keywords: [], slug: "/privacy-policy" },
    terms: { title: "Terms of Use | Container Specialist", description: "Terms of use for Container Specialist.", keywords: [], slug: "/terms-of-use" },
    sitemap: { title: "Sitemap | Container Specialist", description: "Sitemap of the Container Specialist website.", keywords: [], slug: "/sitemap" },
};
